const paramCfas = {
  default: {
    id: 1,
    userLogged: ['cfa', 'antenne'],
    cfa: {
      id: 1
    },
    testOnly: true,
    activities: ['multi'],
    denominations: {
      menuGestion: 'RESEAU APP',
      menuFormation: 'PÉDAGOGIE',
      antenneField: 'Profil du centre',
      codeAnalytiqueField: 'Code analytique',
      antennelModuleName: 'Profil du centre',
      antenneOrDispositif: 'antenne'
    },
    menu: {
      formation: [
        'francecompetences',
        'referentiels',
        'actions',
        'sequences',
        'pif',
        'evaluations',
        'evaluations_cps',
        'tests'
      ],
      facturation: ['aidesmobilises', 'factures'],
      postformation: [
        'suivis',
        'enquetesatisfaction',
        'questionnaireinsertion'
      ],
      gestion: [
        'parametres',
        'referentiels',
        'tableaudebord',
        'antenne',
        'statistiques',
        'gedcollaborative',
        'modeles',
        'gestionutilisateurs'
      ],
      taxes: [],
      candidature: []
    },
    accessRight: {
      hasSectors: true,
      hasAdministrativeBranch: false,
      hasSessions: true,
      hasGroups: true,
      typeDiplome: true,
      hasActionsRatingStars: true,
      hasRepositoriesRatingStars: false,
      canChangeAntenneInSwitchStudent: false,
      gedFolders: ['siège', 'antenne', 'espace_perso', 'pdp'],
      canSeeConventionNumberOnFacturation: true
    },
    conventions: {
      haveFeeTypeShortList: true
    },
    facturation: {
      typeFactureDetails: [
        'pack_informatique',
        'pack_materiel',
        'pack_informatique_1er_acompte',
        'pack_informatique_2eme_acompte',
        'pack_informatique_3eme_acompte',
        'pack_informatique_4eme_acompte',
        'pack_informatique_5eme_acompte',
        'pack_informatique_6eme_acompte'
      ]
    },
    stagiaire: {
      filtres: ['antennes'],
      typeDocumentAdministratifs: [
        'attestation_cpam',
        'attestation_entree_formation',
        'attestation_fin_formation',
        'attestation_inscription_formation',
        'attestation_prise_connaissance',
        'attestation_rqth',
        'autorisation_travail',
        'avis_situation_ft',
        'bulletins_salaire',
        'carte_sejour',
        'cni',
        'consentement_rgpd',
        'contrat_formation',
        'convention_pret_chromebook',
        'convention_stage',
        'droit_image',
        'fiche_prescription',
        'notification_rejet_are_france_travail_moins_3_mois',
        'reglement_interieur',
        'rib',
        'rs1_cerfa_remu'
      ],
      typeDocumentPedagogiques: [
        'non_renseigne',
        'attestation_epmsp',
        'bilan_fin_parcours',
        'bti_entretiens',
        'contrat_pedagogique',
        'evaluations_formatives',
        'positionnement',
        'fiche_mission',
        'grille_certification',
        'livret_suivi_individuel_parcours',
        'test_exigences',
        'visites_structure'
      ]
    },
    entretien: {
      interviewsType: [
        'accompagnement_sante_social',
        'bilan_intermediaire',
        'contractualisation_engagement',
        'entretien_accueil',
        'entretien_ecoute',
        'entretien_bilan_fin_parcours',
        'entretien_referent_handicap',
        'entretien_regulation',
        'entretien_restitution_positionnement',
        'entretien_suivi_pedagogique',
        'entretien_suivi_projet_professionnel',
        'positionnement',
        'signalement'
      ]
    },
    pedagogie: {
      filtres: ['antennes']
    },
    // champ json en bdd
    orderFieldsTrainingForm: {
      type_cursus: 'order-3',
      status: 'order-4',
      type_status_autre_details: 'order-5',
      antenne: 'order-0',
      antenne_secteur: 'order-2',
      antenne_convention: 'order-2',
      type_action: 'order-6',
      diplome: 'order-6',
      module: 'order-6',
      diplome_session: 'order-7',
      action_session: 'order-7',
      antenne_groupe_session: 'order-7',
      dt_date_entree: 'order-8',
      date_entree_prevue: 'order-8',
      date_sortie_prevue: 'order-9',
      date_selection_trials: 'order-10',
      date_selection_requirement: 'order-11',
      date_positioning_start: 'order-12',
      date_positioning_end: 'order-12',
      dt_date_first_contact: 'order-100',
      funding: 'order-101',
      funding_details: 'order-102',
      formation_hours: 'order-103',
      company_hours: 'order-104',
      entreprise_tuteur_title: 'order-200',
      desired_entreprise: '201',
      desired_tutor: 'order-202',
      desired_tutor_lastname: 'order-203',
      desired_tutor_firstname: 'order-204',
      btn_choose_another_tuteur: 'order-205',
      pole_emploi_title: 'order-300',
      pole_emploie_id: 'order-301',
      pole_emploie_since: 'order-302',
      pole_emploie_agency: 'order-303',
      pole_emploie_advisor: 'order-304',
      pole_emploie_advisor_phone: 'order-305',
      formationCustomFields: 'order-306'
    }
  },

}
export const parametrageCfas = {
  namespaced: false,
  state: {
    paramCfas: []
  },
  mutations: {
    setParamCfas(state, paramCfas) {
      state.paramCfas = Object.values(paramCfas)
    }
  },
  actions: {
    fetchParamCfas(context) {
      return context.commit('setParamCfas', paramCfas)
    }
  },
  getters: {
    getParamCfas(state) {
      return state.paramCfas
    },
    getCfaParams: (state) => (userCfaId, userCheckStatus) => {
      if (userCheckStatus) {
        return state.paramCfas.find((cfaParams) => {
          return (
            cfaParams.cfa.id === userCfaId &&
            cfaParams.userLogged.includes('cfa')
          )
        })
      } else {
        return state.paramCfas.find((cfaParams) => {
          return (
            cfaParams.cfa.id === userCfaId &&
            cfaParams.userLogged.includes('antenne')
          )
        })
      }
    }
  }
}
